// The values are defined by the backend
export enum OnboardingType {
  main = 'main',
  topic = 'topic',
  category = 'category',
  filter = 'filter',
  balance = 'balance',
  event = 'event',
  portfolio = 'portfolio',
  referral = 'referral',
  investingLimit = 'investing_limit',
  investingMarket = 'investing_market',
  investingMarketMax = 'investing_market_max',
  exitLimit = 'exit_limit',
  exitMarket = 'exit_market',
}

const ONBOARDING_TYPE_LABELS: Record<OnboardingType, string> = {
  [OnboardingType.main]: 'Main',
  [OnboardingType.topic]: 'Topic',
  [OnboardingType.category]: 'Category',
  [OnboardingType.filter]: 'Filter',
  [OnboardingType.balance]: 'Balance',
  [OnboardingType.event]: 'Event',
  [OnboardingType.portfolio]: 'Portfolio',
  [OnboardingType.referral]: 'Referral',
  [OnboardingType.investingLimit]: 'Investing limit',
  [OnboardingType.investingMarket]: 'Investing market',
  [OnboardingType.investingMarketMax]: 'Investing market max',
  [OnboardingType.exitLimit]: 'Exit limit',
  [OnboardingType.exitMarket]: 'Exit market',
};

export const formatOnboardingType = (type: OnboardingType): string =>
  ONBOARDING_TYPE_LABELS[type] ?? type;

// The values are defined by the backend
export enum OnboardingStatus {
  ready = 'ready',
  completed = 'completed',
}

const ONBOARDING_STATUS_LABELS: Record<OnboardingStatus, string> = {
  [OnboardingStatus.ready]: 'Ready',
  [OnboardingStatus.completed]: 'Completed',
};

export const formatOnboardingStatus = (status: OnboardingStatus): string =>
  ONBOARDING_STATUS_LABELS[status] ?? status;

// Item from GET /admin/onboardings/users/{userId}.
export interface UserOnboardingStatus {
  type: OnboardingType;
  config: string;
  status: OnboardingStatus;
}

// List item from GET /admin/onboardings.
export interface Onboarding {
  type: OnboardingType;
  config: string;
  geoConfigsCount: number;
}

export interface OnboardingGeoConfig {
  id: string;
  countryCode: string;
  config: string;
}

export interface OnboardingExtDataConfig {
  id: string;
  extName: string;
  extValue: string;
  config: string;
  priority: number;
}

// Detail from GET /admin/onboardings/{type}.
export interface OnboardingDetails {
  type: OnboardingType;
  config: string;
  geoConfigs: OnboardingGeoConfig[];
  extDataConfigs: OnboardingExtDataConfig[];
}
